import {z} from 'zod';

export const ArticleCategoryFormSchema = z.object({
  isDefault: z.boolean(),
  active: z.boolean(),
  name: z.string(),
  code: z.string().nullish(),
  system: z.boolean(),
});

export type ArticleCategoryForm = z.infer<typeof ArticleCategoryFormSchema>;
